import { useState } from "react";
import { useSelector } from "react-redux"
import "./forgotPassword.css";
import { instance } from "../../store/utils";
import { Input  } from "antd";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [show, setShow] = useState(false);

  const isLoading = useSelector(state => state.forms.loading)
  
  //handlers
  const handleSubmit = async e => {
    // console.debug("inside ForgotPassword.jsx handleSubmit");
    e.preventDefault();
    const url = `/api/user/userExists/${email}`
    // const url = '/api/user/uallusers';
    try {
      const response = await instance.get(url);
      console.debug("response ",response);
      if (response.status !== 200) {
        console.info("ForgotPassword: Email not found in the database.");
        setLoginError(true); // Update the state to reflect that the email was not found
      } else {
        console.info("ForgotPassword: Email found in the database.");
        setShow(true);
        // You can proceed with the next steps (like sending a password reset link) here
        //Send the first path of the reset link to the user
        const url1 = `/api/user/forgotpassword/${email}`
        const sendResetUrlFirstPart = await instance.get(url1);

        if (sendResetUrlFirstPart.statusText !== "OK") {
          throw new Error(
            "Failed to send reset link. Status: " + sendResetUrlFirstPart.status
          );
        }

        const response = await sendResetUrlFirstPart.json();
        console.info("ForgotPassword - Reset link sent successfully:", response.msg);
      }
    } catch (error) {
      console.error("ForgotPassword - Error fetching users:", error.message);
    }

  };

  return (
    <form className="login" id="forgot-page" onSubmit={handleSubmit}>
      <header id="forgot-password-header">
        <h1 id="login-title">Forgot your password?</h1>
      </header>
      <div id="login-content">
        <div className="form-group" id="forgot-page-form-1">
          <label id="labelEmail">Email</label>
          <Input
            id="inputEmail"
            className={loginError ? "error" : ""}
            type="email"
            onChange={e => setEmail(e.target.value)}
            value={email}
            autoComplete="new-password"
          />
          <span id="error-message">Invalid email.</span>
        </div>

        <div id="backtologin">
          <a href="/regcom/login">« Back to Login</a>
        </div>
        <div id="alert-message"></div>
          {show ? 
              <>
                <span id="succeess-message">
                  Email for password reset has been sent
                </span>
                <br></br>
                <br></br>
              </>
              :
              <></>
            }

        <button className="cursor-pointer" id="forgot-page-button" disabled={isLoading}>
          Submit
        </button>

        <div id="info-text">
          <span>
            Please enter your email address so we can send you an email to reset
            your password.
          </span>
        </div>
      </div>
      {/* {error && <div className="error">{error}</div>} */}
    </form>
  );
};

export default ForgotPassword;
